var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGymBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98602 9.84127H4.49018C3.99161 9.84127 3.56236 10.1831 3.46458 10.6579L2.04133 17.5698C1.78245 18.827 2.77249 20 4.09253 20H4.94004C4.94008 19.9688 4.94209 19.9373 4.94618 19.9055L5.99209 11.7785C6.04582 11.361 6.43787 11.0648 6.86776 11.117C7.29764 11.1692 7.60257 11.55 7.54883 11.9675L6.51509 20H17.4849L16.4512 11.9675C16.3974 11.55 16.7024 11.1692 17.1322 11.117C17.5621 11.0648 17.9542 11.361 18.0079 11.7785L19.0538 19.9055C19.0579 19.9373 19.0599 19.9688 19.06 20H19.9075C21.2275 20 22.2175 18.827 21.9587 17.5698L20.5354 10.6579C20.4376 10.1831 20.0084 9.84127 19.5098 9.84127H18.014C18.014 6.61523 15.3214 4 12 4C8.67857 4 5.98602 6.61523 5.98602 9.84127ZM7.55489 9.84127C7.55489 7.4568 9.54503 5.52381 12 5.52381C14.455 5.52381 16.4451 7.4568 16.4451 9.84127H7.55489Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymBag);
export default __webpack_public_path__ + "static/media/gym-bag.207baec159dc9c7de626afdf63b487c8.svg";
export { ForwardRef as ReactComponent };